import { render } from "./ConfiguracaoInicialEmpresa.vue?vue&type=template&id=eeb30fb8&scoped=true&ts=true"
import script from "./ConfiguracaoInicialEmpresa.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialEmpresa.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialEmpresa.vue?vue&type=style&index=0&id=eeb30fb8&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb30fb8"]])

export default __exports__